<!-- source: https://headlessui.com/v1/vue/disclosure -->

<template>
    <div class="tw:w-full tw:rounded-2xl tw:bg-white">
        <Disclosure v-slot="{ open }">
            <DisclosureButton
                class="tw:flex tw:justify-between tw:w-full tw:font-medium tw:border-b tw:pl-2 tw:pt-10
                       tw:text-gray-400 tw:hover:text-gray-500"
            >
                <span
                    class="tw:tracking-wide tw:uppercase tw:font-semibold"
                >
                    {{ titel }}
                </span>
                <span class="tw:ml-6">
                    <ChevronUpIcon
                        :class="open ? 'tw:rotate-180 tw:transform' : ''"
                        class="tw:size-5"
                    />
                </span>
            </DisclosureButton>
            <DisclosurePanel class="tw:px-4 tw:pt-4 tw:pb-2">
                <slot />
            </DisclosurePanel>
        </Disclosure>
    </div>
</template>

<script setup lang="ts">
import {Disclosure, DisclosureButton, DisclosurePanel} from "@headlessui/vue";
import {ChevronUpIcon} from "@heroicons/vue/20/solid";

defineProps<{
    titel: string;
}>();
</script>

